import Immutable from 'immutable'

type DisplayMessageProps = {
    message: string
}

const DisplayMessageRecord = Immutable.Record({
    message: null,
})

export default class DisplayMessage extends DisplayMessageRecord implements Readonly<DisplayMessageProps>
{
    // message: string
}
